import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import apiData_Reducer from './apiData_Reducer'
import apiAccess_Reducer from './apiAccess_Reducer'

const createAppReducer = (history) => combineReducers({
    apiData: apiData_Reducer,
    apiAccess: apiAccess_Reducer,
    router: connectRouter(history),
})

const createRootReducer = (history) => (state, action) => {
    // if(action.type === 'STATE_RESET') {
    //     let _newState = merge({}, initialState)             // New instance of initialState.
    //     // merge(_newState, action.stateToPreserve)         // Re-store state object passed on as argument to this function.
    //     // merge(_newState, {localize: state.localize})     // Make sure localize is preserved (otherwise reset after login).
    //     return _newState
    // }
    // else if (action.type === 'STATE_RESET__HARD') {
    //     let _newState = merge({}, initialState)             // New instance of initialState.
    //     merge(_newState, {router: state.router})
    //     // merge(_newState, {localize: state.localize}) // Make sure localize is preserved (otherwise reset after login).
    //     return _newState
    // }

    return createAppReducer(history)(state, action)
}

// createRootReducer reset functionality according to the following source (connected-react-router): 
// https://github.com/supasate/connected-react-router/issues/178#issuecomment-439494339
export default createRootReducer